import { Routes, Route } from 'react-router-dom';
import Layout from './pages/layout';
import Home from './pages/home';
import ClientServices from './pages/clientService';
import FinancialTools from './pages/financialPages';
import ContactUs from './pages/contactUs';


function App() {
return (
<Routes>
  <Route element={<Layout />}>
    <Route path="/" element={<Home />} />
    <Route path="/client-services" element={<ClientServices />} />
    <Route path="/financial-tools" element={<FinancialTools />} />
    <Route path="/contact" element={<ContactUs />} />
  </Route>
</Routes>
);
}


export default App;